// this file was auto-generated by rake i18n:generate_js.
// you probably shouldn't edit it directly
import mergeI18nTranslations from 'mergeI18nTranslations';

// we use JSON.parse here instead of just loading it as a javascript object literal
// because according to https://v8.dev/blog/cost-of-javascript-2019#json that is faster
mergeI18nTranslations(JSON.parse("{\"de\":{\"assignments\":{\"available_date_description\":{\"available_until\":\"Verfügbar bis\",\"closed\":\"Geschlossen\",\"not_available_until\":\"Nicht verfügbar bis\"}}},\"hu\":{\"assignments\":{\"available_date_description\":{\"available_until\":\"Elérhető eddig\",\"closed\":\"Lezárva\",\"not_available_until\":\"Nem érhető el eddig\"}}}}"));
